<template>
    <div v-if="title" class="platform-label" :style="elementStyles">
        <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" class="platform-label__svg">
            <g style="transform: translate(12px, 12px)">
                <circle cx="0" cy="0" r="11" stroke="black" stroke-width="1" fill="#ffc700" class="platform-label__circle" />
                <text x="0" y="0" text-anchor="middle" dominant-baseline="central" fill="black" class="platform-label__text">
                    {{ title }}
                </text>
            </g>
        </svg>
    </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';

interface Props {
    title?: string;
    size?: number | string;
}

const props = withDefaults(defineProps<Props>(), { size: 22 });
const size = computed(() => (props.size ? Number(props.size) : 22));
const fontSize = computed(() => `${(120 - (props.title?.length || 1) * 10) / 100}em`);
const elementStyles = computed(() => ({
    width: `${size.value}px`,
    height: `${size.value}px`,
    lineHeight: `${size.value}px`,
    '--font-size': fontSize.value
}));
</script>

<style lang="scss">
.platform-label {
    --font-size: 1.1em;
    display: inline-block;
    font-size: 1rem;

    &__svg {
        display: block;
        height: 100%;
        width: 100%;
    }

    &__text {
        height: 100%;
        width: 100%;
        font-weight: bold;
        font-size: var(--font-size);
    }
}
</style>
